import { EnumDescriptor } from "types/enumDescriptor";

export enum Language {
    FR = "fr",
    EN = "en",
    DE = "de",
    ES = "es",
    AR = "ar",
}

export const LanguageMap = {
    fr: "fr-FR",
    en: "en-US",
    de: "de-DE",
    es: "es-ES",
    ar: "ar-SA",
};

// The language the description is written in, so screen readers pronounce it correctly (RGAA 8.7).
interface LanguageDescriptor extends EnumDescriptor {
    descriptionLanguage: Language;
}

export const LANGUAGES: Array<LanguageDescriptor> = [
    {
        key: Language.FR,
        description: "Français",
        descriptionLanguage: Language.FR,
    },
    {
        key: Language.DE,
        description: "Deutsch",
        descriptionLanguage: Language.DE,
    },
    {
        key: Language.EN,
        description: "English",
        descriptionLanguage: Language.EN,
    },
    // Written in English, unlike the other descriptions.
    {
        key: Language.ES,
        description: "Spanish",
        descriptionLanguage: Language.EN,
    },
    { key: Language.AR, description: "عربي", descriptionLanguage: Language.AR },
];
